import api from '../../config/http-common'

const createMobileKeyConfigurations = (payload) => {
  return api.securedAxios().post('/web/api/v4/mobileKeyConfiguration', payload)
}

const buildQuery = (payload) => {
  let query =
    '?isPagable=true&sort=createdAt%7Cdesc&caseSensitive=false&operator=AND&pageNumber=' +
    payload.page +
    '&pageSize=' +
    payload.rowsPerPage
  return query
}

const getMobileConfigurations = (payload) => {
  return api
    .securedAxios()
    .get(
      '/web/api/v4/mobileKeyConfigurations/' +
      localStorage.getItem('companyId') +
      '/list' +
      buildQuery(payload),
    )
}

const deleteMobileConfiguration = (payload) => {
  return api
    .securedAxios()
    .delete('/web/api/v4/mobileKeyConfigurations/' + payload.id +"?customerName="+payload.customerName +"&numberOfDevices="+payload.numberOfDevices)
}

const updateMobileConfigurations = (payload) => {
  return api
    .securedAxios()
    .put('/web/api/v4/mobileKeyConfigurations/' + payload.id, payload)
}


const MobileKeyConfigurationService = {
  createMobileKeyConfigurations,
  getMobileConfigurations,
  deleteMobileConfiguration,
  updateMobileConfigurations

}

export default MobileKeyConfigurationService
